<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <span></span>
      </template>
    </app-breadcrumb>
    <!-- Filters -->
    <div class="card">
      <div class="card-body p-1">
        <b-row>
          <b-col cols="12"
            md="2">
            <label>Trạng thái</label>
            <b-input-group>
              <v-select v-model="status"
                :options="dataStatus"
                class="w-100"
                label="name"
                :reduce="val => val.id"
                placeholder="--Chọn--" />
            </b-input-group>
          </b-col>
          <b-col cols="12"
            md="6">
            <label>Tìm kiếm</label>
            <b-input-group class="mb-0">
              <b-form-input v-model="localSearchQuery"
                class="d-inline-block"
                placeholder="Từ khóa"
                @keyup.enter="updateSearchQuery" />
              <b-input-group-append>
                <b-button variant="primary"
                  @click="updateSearchQuery">
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- List -->
    <b-overlay :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm">
      <b-card no-body
        class="mb-0">
        <b-table ref="refListTable"
          class="table-responsive table-nowrap"
          :items="dataItems"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching records found">
          <!-- Column: Status -->
          <template #cell(content)="data">
            <span class="title"
              @click="edit(data.item)"><b>{{ data.item.content }}</b></span>
          </template>
          <template #cell(user_id)="data"> {{ data.item.user_info.full_name }} </template>
          <template #cell(status)="data">
            <b-badge variant="light-success"
              v-if="data.item.status == 1"> Đã duyệt </b-badge>
            <b-badge variant="light-secondary"
              v-else-if="data.item.status == 0"> Chờ duyệt </b-badge>
          </template>
          <template #cell(actions)="data">
            <!-- <b-button size="sm"
              class=""
              variant="flat-dark"
              @click="edit(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button> -->
            <b-button size="sm"
              class="ms-2"
              variant="outline-danger"
              @click="onDestroy(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon"
                    size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon"
                    size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal id="modalDialog"
      no-close-on-backdrop
      hide-footer
      body-class="p-0"
      title="Nội dung bình luận"
      @close="hidenModal">
      <comment-show :data-edit="dataEdit"
        @updateList="handleDialog" />
    </b-modal>
  </div>
</template>
<script>
import {
  BCard, BOverlay, BCardBody, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormCheckbox,
  BPagination, BInputGroupAppend, BInputGroup, BBadge
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { showToast } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import CommentShow from './CommentShow.vue'

export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    vSelect,
    CommentShow,
    BBadge
  },
  data() {
    return {
      title: 'Hello world',
      checked: false,
      files: [],
      dataEdit: {},
      dialog_title: 'Thêm mới',
      dataContentType: [
        { label: 'Bài viết', code: 'news' },
        { label: 'Chuyên trang', code: 'content' },
        { label: 'Loại hình xuất bản', code: 'page' },
      ],
    }
  },
  setup() {
    const refListTable = ref(null)
    const tableColumns = [
      { key: 'content', sortable: false, label: 'Nội dung' },
      { key: 'parent_id', sortable: false, label: 'Cấp độ', thAttr: { width: '6%' } },
      { key: 'user_id', sortable: false, label: 'Người tạo', thAttr: { width: '10%' } },
      { key: 'created_at', sortable: false, label: 'Ngày gửi', thAttr: { width: '9%' }, },
      { key: 'status', sortable: false, label: 'Trạng thái', thAttr: { width: '7%' }, },
      { key: 'actions', label: 'Hành động', class: 'action', thAttr: { width: '6%' }, },
    ];
    const perPage = ref(30)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 30, 50, 100]
    const searchQuery = ref('')
    const type = ref('')
    const status = ref('')
    const localSearchQuery = ref('')
    const loading = ref(false)
    const dataItems = ref([])

    const fetchAll = () => {
      loading.value = true
      store.dispatch('comment/fetchAll', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        status: status.value,
        type: type.value,
      })
        .then(response => {
          loading.value = false
          const result = response.data;
          if (result.code === 200) {
            dataItems.value = result.data.data;
            total.value = result.data.total;
          }
        })
    }

    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })

    watch([currentPage, perPage, searchQuery, type, status], () => {
      fetchAll()
    })

    const refetchData = () => {
      fetchAll()
    }
    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value
    }
    const dataStatus = ref([
      { id: 1, name: 'Đã duyệt' },
      { id: 2, name: 'Chưa duyệt' }
    ])
    fetchAll()
    return {
      loading,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      status,
      updateSearchQuery,
      localSearchQuery,
      dataItems,
      type,
      dataStatus
    }
  },
  methods: {
    onDestroy(item) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa bình luận này không?',
        showCancelButton: true,
        cancelButtonText: 'Hủy',
        confirmButtonText: 'Đồng ý',
        customClass: {
          cancelButton: 'btn btn-secondary ml-1 btn-sm',
          confirmButton: 'btn btn-success btn-sm',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          const { id } = item
          store.dispatch('comment/destroy', id)
            .then(response => {
              const rs = response.data
              if (rs.code === 200) {
                showToast(rs.message, { variant: 'success' })
                this.refetchData()
              } else {
                showToast(rs.message)
              }

            })
        }
      })
    },

    hidenModal() {
      this.$bvModal.hide('modalDialog');
      this.dataEdit = {};
    },
    handleDialog() {
      this.$bvModal.hide('modalDialog');
      this.refetchData();
    },
    edit(item) {
      this.dataEdit = item;
      this.dialog_title = 'Cập nhật';
      this.$bvModal.show('modalDialog');
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
